/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtJournalism.id.label': '',
'tqtJournalism.id.holder': '请输入',
'tqtJournalism.id.max': '最多11个字符',
'tqtJournalism.id.required': '必填',
'tqtJournalism.searchId.holder': '搜索',
'tqtJournalism.adminId.label': '',
'tqtJournalism.adminId.holder': '请输入',
'tqtJournalism.adminId.max': '最多11个字符',
'tqtJournalism.adminId.required': '必填',
'tqtJournalism.searchAdminId.holder': '搜索',
'tqtJournalism.title.label': '标题',
'tqtJournalism.title.holder': '请输入标题',
'tqtJournalism.title.max': '标题最多54个字符',
'tqtJournalism.title.required': '标题必填',
'tqtJournalism.searchTitle.holder': '搜索标题',
'tqtJournalism.isShowIndex.label': '是否首页展示',
'tqtJournalism.isShowIndex.holder': '请输入是否首页展示',
'tqtJournalism.isShowIndex.max': '是否首页展示最多1个字符',
'tqtJournalism.isShowIndex.required': '是否首页展示必填',
'tqtJournalism.searchIsShowIndex.holder': '搜索是否首页展示',
'tqtJournalism.indexPic.label': '图片地址',
'tqtJournalism.indexPic.holder': '请输入图片地址',
'tqtJournalism.indexPic.max': '图片地址最多54个字符',
'tqtJournalism.indexPic.required': '图片地址必填',
'tqtJournalism.searchIndexPic.holder': '搜索图片地址',
'tqtJournalism.releaseTime.label': '发布时间',
'tqtJournalism.releaseTime.holder': '请输入发布时间',
'tqtJournalism.releaseTime.max': '发布时间最多null个字符',
'tqtJournalism.releaseTime.required': '发布时间必填',
'tqtJournalism.searchReleaseTime.holder': '搜索发布时间',
'tqtJournalism.status.label': '状态',
'tqtJournalism.status.holder': '请输入状态',
'tqtJournalism.status.max': '状态最多1个字符',
'tqtJournalism.status.required': '状态必填',
'tqtJournalism.searchStatus.holder': '搜索状态',
'tqtJournalism.type.label': '0公告，1广播，2轮播',
'tqtJournalism.type.holder': '请输入0公告，1广播，2轮播',
'tqtJournalism.type.max': '0公告，1广播，2轮播最多1个字符',
'tqtJournalism.type.required': '0公告，1广播，2轮播必填',
'tqtJournalism.searchType.holder': '搜索0公告，1广播，2轮播',
'tqtJournalism.lunboType.label': 'type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.lunboType.holder': '请输入type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.lunboType.max': 'type为2轮播时，该字段值0是pc，1是小程序最多1个字符',
'tqtJournalism.lunboType.required': 'type为2轮播时，该字段值0是pc，1是小程序必填',
'tqtJournalism.searchLunboType.holder': '搜索type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.showType.label': '1三方外链2富文本',
'tqtJournalism.showType.holder': '请输入1三方外链2富文本',
'tqtJournalism.showType.max': '1三方外链2富文本最多1个字符',
'tqtJournalism.showType.required': '1三方外链2富文本必填',
'tqtJournalism.searchShowType.holder': '搜索1三方外链2富文本',
'tqtJournalism.source.label': '(信息来源（链接地址）)',
'tqtJournalism.source.holder': '请输入(信息来源（链接地址）)',
'tqtJournalism.source.max': '(信息来源（链接地址）)最多128个字符',
'tqtJournalism.source.required': '(信息来源（链接地址）)必填',
'tqtJournalism.searchSource.holder': '搜索(信息来源（链接地址）)',
'tqtJournalism.createTime.label': '',
'tqtJournalism.createTime.holder': '请输入',
'tqtJournalism.createTime.max': '最多null个字符',
'tqtJournalism.createTime.required': '必填',
'tqtJournalism.searchCreateTime.holder': '搜索',
'tqtJournalism.updateTime.label': '',
'tqtJournalism.updateTime.holder': '请输入',
'tqtJournalism.updateTime.max': '最多null个字符',
'tqtJournalism.updateTime.required': '必填',
'tqtJournalism.searchUpdateTime.holder': '搜索',
},
'zh-TW': {
'tqtJournalism.id.label': '',
'tqtJournalism.id.holder': '請輸入',
'tqtJournalism.id.max': '最多11個字符',
'tqtJournalism.id.required': '必填',
'tqtJournalism.searchId.holder': '搜索',
'tqtJournalism.adminId.label': '',
'tqtJournalism.adminId.holder': '請輸入',
'tqtJournalism.adminId.max': '最多11個字符',
'tqtJournalism.adminId.required': '必填',
'tqtJournalism.searchAdminId.holder': '搜索',
'tqtJournalism.title.label': '标题',
'tqtJournalism.title.holder': '請輸入标题',
'tqtJournalism.title.max': '标题最多54個字符',
'tqtJournalism.title.required': '标题必填',
'tqtJournalism.searchTitle.holder': '搜索标题',
'tqtJournalism.isShowIndex.label': '是否首页展示',
'tqtJournalism.isShowIndex.holder': '請輸入是否首页展示',
'tqtJournalism.isShowIndex.max': '是否首页展示最多1個字符',
'tqtJournalism.isShowIndex.required': '是否首页展示必填',
'tqtJournalism.searchIsShowIndex.holder': '搜索是否首页展示',
'tqtJournalism.indexPic.label': '图片地址',
'tqtJournalism.indexPic.holder': '請輸入图片地址',
'tqtJournalism.indexPic.max': '图片地址最多54個字符',
'tqtJournalism.indexPic.required': '图片地址必填',
'tqtJournalism.searchIndexPic.holder': '搜索图片地址',
'tqtJournalism.releaseTime.label': '发布时间',
'tqtJournalism.releaseTime.holder': '請輸入发布时间',
'tqtJournalism.releaseTime.max': '发布时间最多null個字符',
'tqtJournalism.releaseTime.required': '发布时间必填',
'tqtJournalism.searchReleaseTime.holder': '搜索发布时间',
'tqtJournalism.status.label': '状态',
'tqtJournalism.status.holder': '請輸入状态',
'tqtJournalism.status.max': '状态最多1個字符',
'tqtJournalism.status.required': '状态必填',
'tqtJournalism.searchStatus.holder': '搜索状态',
'tqtJournalism.type.label': '0公告，1广播，2轮播',
'tqtJournalism.type.holder': '請輸入0公告，1广播，2轮播',
'tqtJournalism.type.max': '0公告，1广播，2轮播最多1個字符',
'tqtJournalism.type.required': '0公告，1广播，2轮播必填',
'tqtJournalism.searchType.holder': '搜索0公告，1广播，2轮播',
'tqtJournalism.lunboType.label': 'type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.lunboType.holder': '請輸入type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.lunboType.max': 'type为2轮播时，该字段值0是pc，1是小程序最多1個字符',
'tqtJournalism.lunboType.required': 'type为2轮播时，该字段值0是pc，1是小程序必填',
'tqtJournalism.searchLunboType.holder': '搜索type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.showType.label': '1三方外链2富文本',
'tqtJournalism.showType.holder': '請輸入1三方外链2富文本',
'tqtJournalism.showType.max': '1三方外链2富文本最多1個字符',
'tqtJournalism.showType.required': '1三方外链2富文本必填',
'tqtJournalism.searchShowType.holder': '搜索1三方外链2富文本',
'tqtJournalism.source.label': '(信息来源（链接地址）)',
'tqtJournalism.source.holder': '請輸入(信息来源（链接地址）)',
'tqtJournalism.source.max': '(信息来源（链接地址）)最多128個字符',
'tqtJournalism.source.required': '(信息来源（链接地址）)必填',
'tqtJournalism.searchSource.holder': '搜索(信息来源（链接地址）)',
'tqtJournalism.createTime.label': '',
'tqtJournalism.createTime.holder': '請輸入',
'tqtJournalism.createTime.max': '最多null個字符',
'tqtJournalism.createTime.required': '必填',
'tqtJournalism.searchCreateTime.holder': '搜索',
'tqtJournalism.updateTime.label': '',
'tqtJournalism.updateTime.holder': '請輸入',
'tqtJournalism.updateTime.max': '最多null個字符',
'tqtJournalism.updateTime.required': '必填',
'tqtJournalism.searchUpdateTime.holder': '搜索',
},
'en-US': {
'tqtJournalism.id.label': '',
'tqtJournalism.id.holder': 'Enter ',
'tqtJournalism.id.max': ' max length: 11',
'tqtJournalism.id.required': ' required',
'tqtJournalism.searchId.holder': 'Search ',
'tqtJournalism.adminId.label': '',
'tqtJournalism.adminId.holder': 'Enter ',
'tqtJournalism.adminId.max': ' max length: 11',
'tqtJournalism.adminId.required': ' required',
'tqtJournalism.searchAdminId.holder': 'Search ',
'tqtJournalism.title.label': '标题',
'tqtJournalism.title.holder': 'Enter 标题',
'tqtJournalism.title.max': '标题 max length: 54',
'tqtJournalism.title.required': '标题 required',
'tqtJournalism.searchTitle.holder': 'Search 标题',
'tqtJournalism.isShowIndex.label': '是否首页展示',
'tqtJournalism.isShowIndex.holder': 'Enter 是否首页展示',
'tqtJournalism.isShowIndex.max': '是否首页展示 max length: 1',
'tqtJournalism.isShowIndex.required': '是否首页展示 required',
'tqtJournalism.searchIsShowIndex.holder': 'Search 是否首页展示',
'tqtJournalism.indexPic.label': '图片地址',
'tqtJournalism.indexPic.holder': 'Enter 图片地址',
'tqtJournalism.indexPic.max': '图片地址 max length: 54',
'tqtJournalism.indexPic.required': '图片地址 required',
'tqtJournalism.searchIndexPic.holder': 'Search 图片地址',
'tqtJournalism.releaseTime.label': '发布时间',
'tqtJournalism.releaseTime.holder': 'Enter 发布时间',
'tqtJournalism.releaseTime.max': '发布时间 max length: null',
'tqtJournalism.releaseTime.required': '发布时间 required',
'tqtJournalism.searchReleaseTime.holder': 'Search 发布时间',
'tqtJournalism.status.label': '状态',
'tqtJournalism.status.holder': 'Enter 状态',
'tqtJournalism.status.max': '状态 max length: 1',
'tqtJournalism.status.required': '状态 required',
'tqtJournalism.searchStatus.holder': 'Search 状态',
'tqtJournalism.type.label': '0公告，1广播，2轮播',
'tqtJournalism.type.holder': 'Enter 0公告，1广播，2轮播',
'tqtJournalism.type.max': '0公告，1广播，2轮播 max length: 1',
'tqtJournalism.type.required': '0公告，1广播，2轮播 required',
'tqtJournalism.searchType.holder': 'Search 0公告，1广播，2轮播',
'tqtJournalism.lunboType.label': 'type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.lunboType.holder': 'Enter type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.lunboType.max': 'type为2轮播时，该字段值0是pc，1是小程序 max length: 1',
'tqtJournalism.lunboType.required': 'type为2轮播时，该字段值0是pc，1是小程序 required',
'tqtJournalism.searchLunboType.holder': 'Search type为2轮播时，该字段值0是pc，1是小程序',
'tqtJournalism.showType.label': '1三方外链2富文本',
'tqtJournalism.showType.holder': 'Enter 1三方外链2富文本',
'tqtJournalism.showType.max': '1三方外链2富文本 max length: 1',
'tqtJournalism.showType.required': '1三方外链2富文本 required',
'tqtJournalism.searchShowType.holder': 'Search 1三方外链2富文本',
'tqtJournalism.source.label': '(信息来源（链接地址）)',
'tqtJournalism.source.holder': 'Enter (信息来源（链接地址）)',
'tqtJournalism.source.max': '(信息来源（链接地址）) max length: 128',
'tqtJournalism.source.required': '(信息来源（链接地址）) required',
'tqtJournalism.searchSource.holder': 'Search (信息来源（链接地址）)',
'tqtJournalism.createTime.label': '',
'tqtJournalism.createTime.holder': 'Enter ',
'tqtJournalism.createTime.max': ' max length: null',
'tqtJournalism.createTime.required': ' required',
'tqtJournalism.searchCreateTime.holder': 'Search ',
'tqtJournalism.updateTime.label': '',
'tqtJournalism.updateTime.holder': 'Enter ',
'tqtJournalism.updateTime.max': ' max length: null',
'tqtJournalism.updateTime.required': ' required',
'tqtJournalism.searchUpdateTime.holder': 'Search ',
}
};